import * as React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  children: any;
  link?: string;
  className?: string;
  handleClick?: any;
}

export default class Button extends React.Component<Props> {
  static defaultProps = {
    className: 'is-primary',
  };

  render() {
    const content = (
      <button className={this.props.className} onClick={this.props.handleClick}>
        {this.props.children}
      </button>
    );
    if (this.props.link !== undefined) {
      return <Link to={this.props.link}>{content}</Link>;
    }
    return content;
  }
}
